module.exports = dr_validations;